import React, { useEffect } from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import FormularioSwitch from "../components/contacto/formulario/switch";
import Footer from "../components/footer/index";
import Headroom from "react-headroom";
import TitleSection from "../components/TitleSection";
import InnerContainer from "../components/InnerContainer";
import { useSEO } from "../hooks/useSEO";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--blanco);
  overflow: hidden;

  
`;

export default function ContactoContainer() {
  // Scroll ni bien carga la página
  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  useSEO({
    title: "Cotizá por WhatsApp | SeguroBici",
    description: "Escribinos por WhatsApp y un asesor te llamará para brindarte la mejor cobertura para tu Bici.",
  });

  return (
    <Container>
      {/* Canonical VivoMarketing */}
      <head>
        <link rel="canonical" href="https://segurobici.com.ar/contacto" />
      </head>
      {/* Header */}
      <Headroom>
        <Header></Header>
      </Headroom>
      {/* Titulo */}
      <TitleSection tituloSpan="Contacto" titulo="" tag="Atención al cliente" descripcion="Comunicate con nosotros" />
      {/* Formulario */}
      <FormularioSwitch></FormularioSwitch>
      {/* Footer */}
      <Footer marcas="active" pagina="institucional"></Footer>
    </Container>
  );
}
